// ✅ Servicio mejorado con AbortController y mejor manejo de errores
export const fetchMeterValue = async (
  meterId: string, 
  signal?: AbortSignal
): Promise<number> => {
    console.log(`Fetching value for meter ${meterId}...`);
    
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            // ✅ Verificar si la operación fue cancelada
            if (signal?.aborted) {
                reject(new Error('Operation was aborted'));
                return;
            }

            // Simulate a 70% chance of success (mejorado de 50%)
            if (Math.random() > 0.3) {
                const randomValue = Math.floor(1000 + Math.random() * 9000);
                console.log(`✅ Successfully fetched value: ${randomValue}`);
                resolve(randomValue);
            } else {
                console.error('❌ Failed to fetch value from Node-RED.');
                reject(new Error('Failed to connect to Node-RED'));
            }
        }, 1000);

        // ✅ Limpiar timeout si se cancela
        signal?.addEventListener('abort', () => {
            clearTimeout(timeoutId);
            reject(new Error('Operation was aborted'));
        });
    });
};

// ✅ NUEVO: Función para llamadas reales a Node-RED (cuando tengas el backend)
export const fetchMeterValueFromNodeRed = async (
  meterId: string,
  signal?: AbortSignal
): Promise<number> => {
  try {
    const response = await fetch(`/api/meter/${meterId}/value`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      signal, // ✅ Pasar AbortController
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.value;
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      console.log('Request was aborted');
      throw error;
    }
    console.error('Error fetching meter value:', error);
    throw new Error('Failed to fetch meter value');
  }
};

// ✅ NUEVO: Función con retry automático
export const fetchMeterValueWithRetry = async (
  meterId: string,
  maxRetries: number = 3,
  signal?: AbortSignal
): Promise<number> => {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await fetchMeterValue(meterId, signal);
    } catch (error) {
      if (signal?.aborted || attempt === maxRetries) {
        throw error;
      }
      console.log(`Attempt ${attempt} failed, retrying...`);
      await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
    }
  }
  throw new Error('Max retries exceeded');
};